<template>
  <div class="tenant-error-page">
    <v-card class="tenant-error-card" max-width="480">
      <v-icon size="64" color="error" class="mb-4">mdi-domain-off</v-icon>
      <h1 class="text-h5 mb-2">{{ t('tenantError.title') }}</h1>
      <p class="text-body-1 mb-6">{{ message }}</p>
      <v-btn color="primary" variant="outlined" @click="goHome">
        {{ t('notFound.goToDashboard') }}
      </v-btn>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useTenantStore } from '@/stores/tenant';

const { t } = useI18n();
const router = useRouter();
const tenantStore = useTenantStore();

const message = computed(() => {
  const code = tenantStore.tenantErrorCode;
  switch (code) {
    case 'tenant_not_found':
      return t('tenantError.tenantNotFound');
    case 'tenant_inactive':
      return t('tenantError.tenantInactive');
    case 'subscription_expired':
      return t('tenantError.subscriptionExpired');
    default:
      return t('tenantError.tenantConfig');
  }
});

function goHome() {
  window.location.href = '/';
}
</script>

<style scoped>
.tenant-error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: rgb(var(--v-theme-surface));
}

.tenant-error-card {
  padding: 2.5rem;
  text-align: center;
}
</style>
